import React from "react";
import RcPagination, {PaginationProps} from "rc-pagination";
import "rc-pagination/assets/index.css";
import locale from "rc-pagination/lib/locale/en_US";

import "./style.scss";

export const Pagination = (props: PaginationProps) => (
  <RcPagination {...props} />
);

Pagination.defaultProps = {
  locale,
};
